<template>
  <div class="content-wrapper questionnaire-start">
    <div class="d-flex align-items-center full-height justify-content-center">
        <div class="center">
            <h3>Questionnaire</h3>
            <div class="m-5">
                <p class="general-content">
                  Before we begin the configuration process it's importantn to know a little more about you,<br>
                why you ride and how you ride. The questionnaire takes less than five minutes but it can<br>
                be skipped at ant point.
                </p>
            </div>
            <button class="btn btn-outline-primary" v-on:click="$emit('go-next')">Start configuration</button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "questionnaire-start",
  data() {
    return {}
  }
}
</script>

